import { render, staticRenderFns } from "./NovaReserva.vue?vue&type=template&id=1c8bcfac&scoped=true&"
import script from "./NovaReserva.vue?vue&type=script&lang=js&"
export * from "./NovaReserva.vue?vue&type=script&lang=js&"
import style0 from "./NovaReserva.vue?vue&type=style&index=0&id=1c8bcfac&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bcfac",
  null
  
)

export default component.exports